/* eslint-disable no-unused-expressions */
import { useEffect, useState } from 'react';
import HealthCareFilter from '../Forms/healthCareFilter/HealthCareFilter';
import './stickySearchBar.css';

function StickySearchBar() {
  const [stickyClass, setStickyClass] = useState('relative');
  const stickNavbar = () => {
    if (window !== undefined) {
      const windowHeight = window.scrollY;
      windowHeight > 200 ? setStickyClass('active1') : setStickyClass('wait');
    }
  };

  useEffect(() => {
    window.addEventListener('scroll', stickNavbar);
    return () => {
      window.removeEventListener('scroll', stickNavbar);
    };
  }, []);

  return (
    <section className={`stickySearchBar ${stickyClass}`}>
      <HealthCareFilter />
    </section>
  );
}

export default StickySearchBar;
